export interface RelevancePillStyle {
  background: string;
  color: string;
  borderColor: string;
}

export function getPillStyleForRelevanceLabel(label?: string): RelevancePillStyle {
  switch (label) {
    case 'Highly Recommended':
      return {
        background: '#EEF6EF',
        color: '#1F6E3D',
        borderColor: '#D2E5D1',
      };
    case 'Recommended':
      return {
        background: '#EAF0FF',
        color: '#1E40AF',
        borderColor: '#C8D7FF',
      };
    case 'Worth Considering':
      return {
        background: '#FEF5D6',
        color: '#7C4D1E',
        borderColor: '#F7E4A6',
      };
    case 'Less Relevant':
      return {
        background: '#F3F4F6',
        color: '#6B7280',
        borderColor: '#E5E7EB',
      };
    default:
      return {
        background: '#F3F4F6',
        color: '#6B7280',
        borderColor: '#D1D5DB',
      };
  }
}
